/** 接口根路径；开发环境默认 /wuhan-api，由 vue.config.js 代理到真实域名，避免 CORS。 */
function resolveApiBase() {
  const fromEnv = process.env.VUE_APP_API_BASE;
  if (fromEnv != null && String(fromEnv).trim() !== "") {
    return String(fromEnv).replace(/\/$/, "");
  }
  return process.env.NODE_ENV === "development"
    ? "/wuhan-api"
    : "https://wuhanapi.shanghaibianchen.com";
}

export const API_BASE = resolveApiBase();
